import { NameDto } from 'api/Common/Types'

enum RebatePeriod {
  Weekly = 1,
  Every2Weeks = 2,
  Monthly = 3,
}

enum RebateApprovalType {
  Manual = 1,
  Automatic = 2,
}

export interface IntroducingBrokerRebate {
  tradingAccount: NameDto<string>
  rebateApprovalType: NameDto<RebateApprovalType>
  rebatePeriod: NameDto<RebatePeriod>
  rebateAmountInPercentage: number
  isDefault: boolean
  rebateGroup?: NameDto<string>
  selected?: boolean
}

export interface IntroducingBrokerRebateGroup extends NameDto<string> {
  rebateApprovalType: NameDto<RebateApprovalType>
  rebatePeriod: NameDto<RebatePeriod>
  rebateAmountInPercentage: number
  isDefault: boolean
  tradingAccountsCount: number
}

export interface CreateUpdateRebateGroup {
  name?: string
  rebateApprovalType?: NameDto<RebateApprovalType>
  rebatePeriod?: NameDto<RebatePeriod>
  rebateAmountInPercentage?: number
  isDefault?: boolean
  tradingAccountsCount?: number
}

export interface IBIndividualRebate {
  rebateApprovalTypeId: number
  rebatePeriodId: number
  rebateAmountInPercentage: number
  isDefault: boolean
  tradingAccountIds?: string[]
}

export type IBIndividualRebateData = Omit<IBIndividualRebate, 'tradingAccountIds'>

export interface CreateRebateGroup extends IBIndividualRebate {
  name: string
}

export enum RebateFilterKey {
  TradingAccountName = 'TradingAccountName',
  hasRebate = 'HasRebate',
  hasTradingAccountRebate = 'HasTradingAccountRebate',
  hasGroupRebate = 'HasGroupRebate',
  groupName = 'GroupName',
  name = 'Name',
  rebateApprovalType = 'RebateApprovalType',
  rebatePeriod = 'RebatePeriod',
  amount = 'Amount',
  tradingAccountsCount = 'TradingAccountsCount',
  isDefault = 'IsDefault',
}
